/*eslint angular/file-name: 0*/
(function() {
    'use strict';
    angular
        .module('emarket.main.store', [ 'ui.router' ])
        .config(['$stateProvider', function($stateProvider) {
            $stateProvider.state('main.store', {
                url: '/tiendas',
                views: {
                    main: {
                        controller: 'StoreListController as model',
                        templateUrl: 'main/store/store.tpl.html'
                    }
                }
            });
        }]);
}());

/*eslint angular/file-name: 0*/
(function() {
    'use strict';
    angular
        .module('emarket.main.store', [ 'ui.router' ])
        .config(['$stateProvider', function($stateProvider) {
            $stateProvider.state('main.store', {
                url: '/tiendas',
                views: {
                    main: {
                        controller: 'StoreListController as model',
                        templateUrl: 'main/store/store.tpl.html'
                    }
                }
            });
        }]);
}());
